// client/src/components/admin/AdminSettings.js
import { useEffect, useState } from 'react';
import FeatureFlagsPanel from './settings/FeatureFlagsPanel';
import IntegrationsPanel from './integrations/IntegrationsPanel';

function readSub() {
  const m = /(?:^|[#&])sub=(flags|integrations)/.exec(window.location.hash || '');
  return m ? m[1] : 'flags';
}

export default function AdminSettings() {
  const [sub, setSub] = useState(readSub);

  useEffect(() => {
    const onHash = () => setSub(readSub());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const pick = (next) => {
    setSub(next);
    window.location.hash = `sub=${next}`;
  };

  return (
    <div className="admin-settings-page">
      <div className="set-segmented" role="tablist" aria-label="Settings sections">
        <button
          type="button" role="tab" aria-selected={sub === 'flags'}
          className={`set-seg-btn ${sub === 'flags' ? 'is-active' : ''}`}
          onClick={() => pick('flags')}
        >Feature flags</button>
        <button
          type="button" role="tab" aria-selected={sub === 'integrations'}
          className={`set-seg-btn ${sub === 'integrations' ? 'is-active' : ''}`}
          onClick={() => pick('integrations')}
        >Integrations</button>
      </div>
      {sub === 'integrations' ? <IntegrationsPanel /> : <FeatureFlagsPanel />}
    </div>
  );
}
